import { useEffect, useState } from "react"
import { BtnSearch, Overlay, TermGoodsWrapper, Title, Wrapper, WrapperIcon, WrapperTerm } from "./styles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { Badge, Stack, Chip } from "@mui/material";


export const TermGoods = ({ termSearch, setTermSearch, _filterMode, goodsClassList }) => {

  const [colorLevel, setColorLevel] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [ggClassList, setGgClassList] = useState();


  // 0: 全て, 1: お気に入りのみ, 2: 定番
  const [filterMode, setFilterMode] = useState(_filterMode || 0);

  const onHandleFilterModeChange = (e) => {
    const num = Number(e.target.value || 0);
    setFilterMode(num);
    setTermSearch((preValue) => ({ ...preValue, filterMode: num }));
  }

  const onHandleColorLevel = (e) => {
    const isChecked = e.target.checked;
    setColorLevel(isChecked);
    setTermSearch((preValue) => ({ ...preValue, colorLevel: isChecked }));
  }

  const handleSelectClass = (goodsGroupClassID) => {
    const tempList = ggClassList.map(item => {
      if (item.GoodsGroupClassID === goodsGroupClassID) {
        return { ...item, selected: !item.selected };
      }
      return item;
    });
    setGgClassList([...tempList]);
  }

  const handleSettingFilter = () => {
    const selectedClassIDs = ggClassList.filter(item => item.selected).map(item => item.GoodsGroupClassID);
    setTermSearch((preValue) => ({ ...preValue, goodsGroupClassIDs: selectedClassIDs }));
    setShowFilter(false);
  }

  const handleSHowFilter = () => {
    setShowFilter(!showFilter);
    const selectedClassIDs = termSearch?.goodsGroupClassIDs || [];
    const tempList = ggClassList.map(item => {
      if (selectedClassIDs.includes(item.GoodsGroupClassID)) {
        return { ...item, selected: true };
      }
      return { ...item, selected: false };
    });
    setGgClassList([...tempList]);
  }
  // Set Goods Class List
  useEffect(() => {
    if (!goodsClassList?.length) return;
    const tempList = goodsClassList.map(item => ({ ...item, selected: false }));
    setGgClassList([...tempList]);
  }, [goodsClassList])

  return <>
    <TermGoodsWrapper>
      {/* 検索条件 */}
      <div>
        <input type="radio" id="all-id" name="search-type"
          value={0}
          checked={filterMode === 0}
          onChange={onHandleFilterModeChange}
        />
        <label htmlFor="all-id">全て</label>
        <input type="radio" id="favorite-id" name="search-type"
          value={1}
          checked={filterMode === 1}
          onChange={onHandleFilterModeChange} />
        <label htmlFor="favorite-id">お気に入りのみ</label>
        <input type="radio" id="popular-id" name="search-type"
          value={2}
          checked={filterMode === 2}
          onChange={onHandleFilterModeChange} />
        <label htmlFor="popular-id">定番｜</label>

        {/* 調色品 */}
        <input type="checkbox" id="color-level" name="search-type"
          value={1}
          checked={colorLevel}
          onChange={onHandleColorLevel} />
        <label htmlFor="color-level">調色品</label>
      </div>

      {/* Filter */}
      <WrapperIcon>
        <Badge color="secondary" overlap="circular" badgeContent=" " variant="dot" invisible={!(termSearch?.goodsGroupClassIDs?.length > 0)}>
          <span onClick={() => { handleSHowFilter() }}>
            <FontAwesomeIcon icon={faFilter} />
          </span>
        </Badge>
      </WrapperIcon>

      {/* Setting Filter */}
      {!!showFilter && (
        <>
          <Overlay onClick={() => setShowFilter(false)} />
          <Wrapper>
            <Title>検索条件</Title>
            <WrapperTerm>
              {/* <FormGroup>
                {goodsClassList.map((item, index) => (
                  <FormControlLabel key={`ggc_${item.GoodsGroupClassID}`} control={<Checkbox />} label={item.GoodsGroupClassName} />
                ))}
              </FormGroup> */}
              <Stack direction="row" spacing={"4px"} useFlexGap sx={{ flexWrap: 'wrap' }}>
                <Stack justifyContent={"center"} sx={{ fontWeight: "bold" }}>カテゴリー：</Stack>
                {ggClassList?.map((item) => (
                  <Chip key={`ggc_${item.GoodsGroupClassID}`}
                    label={item.GoodsGroupClassName}
                    variant={!item.selected ? "outlined" : "filled"}
                    color={item.selected ? "primary" : "default"}
                    sx={{ '& .MuiChip-label': { fontSize: '1rem' } }}
                    onClick={() => { handleSelectClass(item.GoodsGroupClassID) }} />
                ))}
              </Stack>
            </WrapperTerm>
            <div style={{ display: "flex", justifyContent: "center", position: "fixed", bottom: "0", right: "0", left: "60px" }}>
              <BtnSearch onClick={() => { handleSettingFilter() }}>決定</BtnSearch>
            </div>
          </Wrapper>
        </>
      )}
    </TermGoodsWrapper >
  </>
}
